import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "../../axiosServices";
import QueryGlobalInterface from "../../../interfaces/queryInterface";

export interface useListarUsuariosPorEquipeInterface {
  IdEquipe?: string[] | null;
  IdsBandeiras?: string[];
  IdsCorretores?: string[];
  IdUsuarioLider?: string[];
  IdsUsuarioLider?: string[];
}

export function useListarUsuariosPorEquipe(
  props: useListarUsuariosPorEquipeInterface & QueryGlobalInterface
) {
  const fetchData = async () => {
    const hasIdEquipe = props.IdEquipe ? `&IdEquipe=${props.IdEquipe}` : "";
    const hasIdsCorretores = props.IdsCorretores
      ? `&IdsCorretores=${props.IdsCorretores}`
      : "";
    const hasIdUsuarioLider = props.IdUsuarioLider
      ? `&IdUsuarioLider=${props.IdUsuarioLider}`
      : "";
    const hasIdsUsuarioLider = props.IdsUsuarioLider
      ? props.IdsUsuarioLider.map((id) => `&idsUsuarioLider=${id}`).join("")
      : "";
    const LISTAR_USUARIOS_POR_EQUIPE = `identity/usuario/v1/listar-usuarios-por-equipe?${hasIdEquipe}${hasIdsCorretores}${hasIdUsuarioLider}${hasIdsUsuarioLider}`;
    const response = await instance.get(LISTAR_USUARIOS_POR_EQUIPE);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 2,
    cacheTime: 0,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar usuarios por equipe. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
